import { pagesConfig } from '../../../shared/pages-config';
import LabelManagerGrid from './label-manager-grid';
import NotFoundPage from '../../../shared/not-found-page';
import { isFeatureEnabled } from '../../../utils/feature-flags';
import { useUserSettings } from '../../../utils/use-user-settings';
import SharedBreadcrumbsPage from '../../../shared/simple-breadcrumbs-page';
import { ModuleList } from '../../../shared/analytics/module-list';
export default function LabelManagerPage() {
  const { features } = useUserSettings();
  if (!isFeatureEnabled('driveLabelsRead', features)) {
    return <NotFoundPage />;
  }
  return (
    <SharedBreadcrumbsPage
      breadcrumbs={[
        {
          label: ModuleList.modules.administration.name,
        },
        {
          label: pagesConfig.driveLabelsManager.name,
        },
      ]}
      bookmarkKey={pagesConfig.driveLabelsManager.value}
      infoTooltip="Comprehensive governance tool for Google Drive."
    >
      <LabelManagerGrid />
    </SharedBreadcrumbsPage>
  );
}
